import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ResetPassword = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "reset-password" */ './hocs')),
});
